var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedrightarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cc121d;}.b{fill:none;stroke:#fff;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.264)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(0.264)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.226 71.93) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0S19.449,9.259,21.526,21.95",
    transform: "translate(0 31.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.12,0S.086,12.964,0,21.865",
    transform: "translate(21.696 31.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0V53.477",
    transform: "translate(21.699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedrightarrow);
export default __webpack_public_path__ + "static/media/redrightarrow.01d6bb0e19e4dac7e720d65e1704f1a2.svg";
export { ForwardRef as ReactComponent };